import { useMutation, UseMutationResult } from "react-query";

import { ApiRoutes } from "../../constants/ApiRoutes";
import { httpClient } from "../../api-legacy/BaseApi";

export function useSavePerioChartMutation(): UseMutationResult<unknown, Error, any> {
  return useMutation((data) => httpClient.put(ApiRoutes.savePerioExamItem, { data }));
}
